<template>
  <div>
    <ButtonX />
    <b-container>
      <h1>Hoffnungen und Realitäten zur Wiedervereinigung Deutschlands</h1>
      <p>
        Mit dem Leben in der DDR waren auch viele Einschränkungen des Lebens jedes einzelnen verbunden. Daraus ergab
        sich, dass sich die Menschen vieles von der Wiedervereinigung der beiden Teile Deutschlands erhofften.
      </p>
      <p>Woraus diese Hoffnungen genau bestanden und ob diese erfüllt wurden, haben wir unsere Interviewpartner gefragt:</p>
      <table>
        <colgroup>
          <col style="width: 33%" />
          <col style="width: 33%" />
          <col style="width: 33%" />
        </colgroup>
        <tbody>
          <tr class="tabletop">
            <td>Interviewpartner (Geschlecht, Alter und Wohnort zum Zeitpunkt der Wiedervereinigung)</td>
            <td>Was erhofften Sie sich von der Wiedervereinigung Deutschlands?</td>
            <td>Wurden Ihre Hoffnungen erfüllt? Wenn nein, wie war es dann?</td>
          </tr>
          <tr class="even">
            <td>Männlich, 11 Jahre, Quedlinburg (heutiges Sachsen-Anhalt)</td>
            <td>„Als damaliges Kind: Die tollen Spielsachen und Süßigkeiten aus dem Westen!!!&quot;</td>
            <td>„Ja, in vollem Maße.&quot;</td>
          </tr>
          <tr class="odd">
            <td>Weiblich, 27 Jahre, Berlin Panko (Ostberlin)</td>
            <td>
              „Damals war dort die Freude, dass das Leben wirklich losgeht, insbesondere durch die größeren
              Freiheiten (Reisefreiheit), die er erlauben in den Westen zu reisen und dort am Leben teilzunehmen.
              Natürlich spielte auch der Gedanke an eine bessere Versorgung, wer das nicht sagt lügt, eine Rolle.
              Bananen und Kaffee waren damals im Kommunismus einfach unerschwinglich in der DDR.&quot;
            </td>
            <td>
              „Sie haben sich erfüllt. Es gibt deutlich mehr Freiheit, was jeder bestätigen kann, der einmal im
              Osten war. Auch vom Gesamtgefühl gibt es keine Angst vor Kontrolle durch den Staat, keine Bestimmung
              des persönlichen Lebens durch den Staat oder Angst davor, dass es Aktionen durch die
              Staatssicherheit gibt. Letztere Furcht ist insbesondere von mir abgefallen, weil diese Gefahr
              bestand, da es in meiner Familie Republikflüchtlinge gab.&quot;
            </td>
          </tr>
          <tr class="even">
            <td>Männlich, 36 Jahre, Wilmersdorf (Westberlin)</td>
            <td>
              „Demokratische Verhältnisse in der ehemaligen DDR, mehr Europa in Europa → mehr „europäisches&quot;
              Denken&quot;
            </td>
            <td>„Demokratie wurde erfüllt, europäisches Denken nicht → es gab mehr Fremdenhass&quot;</td>
          </tr>
          <tr class="tablebottom">
            <td>Männlich, 42 Jahre, Pfalz</td>
            <td>
              „Für viele Menschen im Osten ein besseres Leben – alle Lebensmittel, keine Warteschlangen beim
              Bäcker oder Metzger, Einkaufsmärkte, Autos schnell lieferbar, Baumärkte, Baumaterial und - Farbe
              immer verfügbar, Urlaubsreisen wohin man will. Freiheit - ohne Angst, der gegenüber ist ein Spitzel
              (das hat die Menschen stark geprägt).&quot;
            </td>
            <td>
              „Vieles ist eingetreten wie erhofft. Es war auch klar, dass es unzufriedene gibt (wie überall) -
              „früher war alles besser“. Die nachgewachsene Generation kennt nichts anderes und lebt in unserer
              Gesellschaft. Nur einige lassen sich aber zum Teil verhetzen (gibt es auch überall) und wünschen das
              alte System (in Unkenntnis, wie es wirklich für den „kleinen Bürger” war).&quot;
            </td>
          </tr>
        </tbody>
      </table>
      <p>
        Aus den oben genannten Aussagen lässt sich schließen, dass nicht nur der Wunsch nach materiellen Dingen, sondern
        vor allem der Wunsch nach mehr Freiheit und Selbstbestimmung im Vordergrund stand.
      </p>
      <p>
        Nur wenige unserer Interviewpartner hatten Erwartungen an die Wiedervereinigung Deutschlands. Das liegt daran,
        dass sie zu diesem Zeitpunkt noch sehr jung waren und sich deshalb noch nicht bewusst über die Zustände in der
        DDR waren. Andere antworteten auf unsere Frage nach Hoffnungen zur Wiedervereinigung, dass sie nichts anderes
        kannten als das, was sie hatten und somit keine Wünsche und Erwartungen hatten.
      </p>
      <p>
        Zusammengefasst lässt sich dennoch sagen, dass sich die damaligen Wünsche und Hoffnungen weitestgehend erfüllt
        haben.
      </p>
      <div class="bib">
        <h2 class="bib">Quellen</h2>
        <p class="bib">Interviews mit Zeitzeugen, durchgeführt im Herbst 2020</p>
      </div>
      <Footer />
    </b-container>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>